import { ReactNode } from 'react';
import { colors } from '../../../../../../colorVars';
import { Body4 } from '../../../../../atomic/text/Text';

type Props = {
  children: ReactNode;
  label: string;
  margin?: string;
};

export const TopRowInputLabel = ({ children, label, margin }: Props) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', margin }}>
      <Body4 color={colors.lightGrey}>{label}</Body4>
      {children}
    </div>
  );
};
